import React, { Component } from 'react';
import * as signalR from "@microsoft/signalr";

export class Home extends Component {
    static displayName = Home.name;


    constructor(props) {
        super(props);
        this.getVersion = this.getVersion.bind(this);
        this.state = {
            toD365Messages: [],
            fromD365Messages: [],
            errors: [],
            currentVersion: "",
            buildDate: "",
        };
        
    }

    getVersion() {
        let json = require('../version.json');
        //let json = require('/components/version.json');
        this.setState({
            currentVersion: json.version,
            buildDate: json.buildDate
        });
    }

    componentDidMount() {
        this.getVersion();
        let hubConnection = new signalR.HubConnectionBuilder()
            .withUrl("/queue")
            .configureLogging(signalR.LogLevel.Information)
            .build();

        hubConnection.start().then(a => {
            console.log('Hub connection started');
        });

        hubConnection.on("toD365", (message) => {
            console.log(message);
            let toD365Messages = this.state.toD365Messages.concat([message]);
            this.setState({ toD365Messages });
        });

        hubConnection.on("error", (message) => {
            console.log(message);
            let errors = this.state.errors.concat([message]);
            this.setState({ errors });
        });

        hubConnection.on("fromD365", (message) => {
            console.log(message);
            let fromD365Messages = this.state.fromD365Messages.concat([message]);
            this.setState({ fromD365Messages });
        });
    };
    clear() {
        // let fromD365Messages = [];
        // let toD365Messages = [];
        this.setState({ fromD365Messages: [], toD365Messages: [], errors: [] });
    }

 
    render() {
        return (
            <div>
                <button className="btn btn-danger" onClick={e => this.clear()}>Clear</button>
                <div className="row">
                    <div style={{ width: 50 + '%' }}>
                        <h4>To D365</h4>
                        <div className="queue-log" >
                            {this.state.toD365Messages.map((message, index) => (
                                <span style={{ display: 'block' }} key={index}>{message} </span>
                            ))}
                        </div>
                    </div>

                    <div style={{ width: 50 + '%' }}>
                        <h4>From D365</h4>
                        <div className="queue-log" >
                            {this.state.fromD365Messages.map((message, index) => (
                                <span style={{ display: 'block' }} key={index}>{message} </span>
                            ))}
                        </div>
                    </div>
                </div >
                <div>
                    <h4>Errors</h4>
                    <div className="error-log" >
                        {this.state.errors.map((message, index) => (
                            <span style={{ display: 'block' }} key={index}>{message} </span>
                        ))}
                    </div>
                </div >
                <div>
                    <h4>Version</h4>
                    <p aria-live="polite">Version: <strong>{this.state.currentVersion}</strong></p>
                    <p aria-live="polite">Build Date: <strong>{this.state.buildDate}</strong></p>
                </div>
             </div>
        );
    }
}
